export default "__VITE_ASSET__CO64F8EN__"